<template>
  <div class="optimize_target">
    <p class="level-2">
      优化目标
      <el-popover placement="top" trigger="hover" width="400">
        <p style="font-size: 12px; line-height: 1.8">
          选择优化目标后，系统向最有可能发生该目标行为的用户展示你的广告：巨量千川会根据你的投放设置，对您的广告进行内容/格式优化并投放至多个流量场景
        </p>
        <i class="el-icon-question" slot="reference"></i>
      </el-popover>
    </p>
    <div class="list-delivery-methods">
      <div
        class="external-action-card-item"
        :class="{ active: form.action == item.name, disabled: item.disabled }"
        v-for="(item, idx) in externalActions"
        :key="idx"
        @click="handleChange(item.name)"
      >
        <div class="left-part">
          <el-image class="icon" :src="item.icon" fit="fit"></el-image>
        </div>
        <div class="right-part">
          <p class="name">{{ item.name }}</p>
          <p class="content">{{ item.content }}</p>
        </div>
      </div>
    </div>

    <div
      class="right-card"
      :style="{ top: top + 'px' }"
      v-show="form.mode == '放量投放'"
    >
      <p class="title">{{ cardTitle }}</p>
      <p class="number-block">
        {{ numberFormat(numMin).value
        }}<span class="unit">{{ numberFormat(numMin).unit }}</span> ~
        {{ numberFormat(numMax).value }}
        <span class="unit">{{ numberFormat(numMax).unit }}</span>
      </p>
      <p class="ea-text">
        预估带来{{ estimateText }} {{ eaMin }} ~ {{ eaMax }}
      </p>
      <p class="tip">实际效果与创意质量有关</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: Object,
    externalActions: Array,
    cardTitle: String,
    top: Number,
  },
  data() {
    return {};
  },
  watch: {
    "form.planHosting"(val) {
      this.externalActions[1].disabled = val == "开启";
      this.externalActions[2].disabled = val == "开启";
    },
  },
  computed: {
    estimateText() {
      if (this.form.action == "商品购买") return "下单量";
      else if (this.form.action == "粉丝提升") return "新增粉丝量";
      else if (this.form.action == "点赞评论") return "点赞/评论量";
      else if (this.form.action == "进入直播间") return "观看量";
      else if (this.form.action == "直播间商品点击") return "商品点击量";
      else if (this.form.action == "直播间下单") return "下单量";
      else if (this.form.action == "直播间成交量") return "成交量";
      else if (this.form.action == "直播间粉丝提升") return "新增粉丝量";
      else if (this.form.action == "直播间评论") return "评论量";
    },
    numMin() {
      let magnification;
      if (this.cardTitle == "预估展现量") magnification = 2710;
      else magnification = 347;
      return ((this.form.budget / 100) * magnification).toFixed(0);
    },
    numMax() {
      let magnification;
      if (this.cardTitle == "预估展现量") magnification = 5420;
      else magnification = 651;

      return ((this.form.budget / 100) * magnification).toFixed(0);
    },
    eaMin() {
      let magnification;
      if (this.cardTitle == "预估展现量") magnification = 2.3;
      else magnification = 347;
      return ((this.form.budget / 100) * magnification).toFixed(0);
    },
    eaMax() {
      let magnification;
      if (this.cardTitle == "预估展现量") magnification = 4.4;
      else magnification = 651;
      return ((this.form.budget / 100) * magnification).toFixed(0);
    },
  },
  methods: {
    handleChange(name) {
      if (this.form.planHosting == "开启") return;
      this.form.action = name;
    },
    numberFormat(value) {
      let param = {};
      let k = 10000;
      let sizes = ["", "万", "亿", "万亿"];
      let i;
      if (value < k) {
        param.value = value;
        param.unit = "";
      } else {
        i = Math.floor(Math.log(value) / Math.log(k));
        param.value = (value / Math.pow(k, i)).toFixed(2);
        param.unit = sizes[i];
      }
      return param;
    },
  },
};
</script>

<style lang="less" scoped>
.optimize_target {
  position: relative;
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
    .el-icon-question {
      margin-left: 3px;
      color: #d3d3d3;
      font-size: 16px;
      vertical-align: -1px;
      cursor: pointer;
    }
  }
  .list-delivery-methods {
    width: 648px;
    .external-action-card-item {
      display: inline-block;
      margin-bottom: 15px;
      padding: 18px 0 13px 18px;
      width: 200px;
      border: 1px solid transparent;
      border-radius: 4px;
      background-color: #f2f2f2;
      cursor: pointer;
      user-select: none;
      &:hover {
        background-color: #edf1fd;
      }
      &.active {
        background-color: #fff;
        border: 1px solid #194ce5;
        box-shadow: 0 0 2px rgba(0, 0, 0, 10%);
      }
      &.disabled {
        opacity: 0.3;
        cursor: not-allowed;
        &:hover {
          background-color: #f2f2f2;
        }
      }
      &:not(:nth-child(3n)) {
        margin-right: 24px;
      }
      .left-part,
      .right-part {
        display: inline-block;
        vertical-align: top;
        &.right-part {
          margin-left: 15px;
          .name {
            line-height: 20px;
            font-weight: 500;
            font-size: 14px;
            color: #333;
          }
          .content {
            line-height: 17px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.4);
          }
        }
      }
    }
  }
  .right-card {
    position: absolute;
    right: 0;
    padding: 24px;
    border: 1px solid #e3e3e4;
    border-radius: 4px;
    width: 310px;
    height: 151px;
    .title {
      line-height: 22px;
      font-weight: 600;
      font-size: 16px;
    }
    .number-block {
      margin-top: 4px;
      line-height: 33px;
      font-family: OPPOSans-H;
      font-weight: 800;
      font-size: 24px;
      color: #111;
      .unit {
        line-height: 22px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #111;
      }
    }
    .ea-text {
      margin-top: 8px;
      line-height: 17px;
      font-size: 12px;
      color: #666;
    }
    .tip {
      margin-top: 4px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>